import { memo, useMemo } from 'react';
import {
  listIconSocialLink,
  socialMediaData,
  socialMediaUrls,
} from '../../../../constant/user-setting-modal-resources';

import {
  IDetailProfileInfoFC as ISocialLinkProps,
  UserSettingEnum,
} from '../../../../interfaces/profile.interface';
import ProfileInfoEditButton from '../button/ProfileInfoEditButton';

const SocialLinkComponent: React.FC<ISocialLinkProps> = ({
  data,
  roleView,
  setModal,
}) => {
  const item = useMemo(() => data, [data]);
  console.log(item, socialMediaUrls[item.socialNetwork]);
  return (
    <div className="flex justify-between py-2 bg-[#2691BD]/[4%] rounded-[10px] px-3">
      <a
        href={item.link}
        target="_blank"
        className="cursor-pointer flex w-full"
        rel="noreferrer"
      >
        <span className="flex items-center w-[36px] sm:w-fit">
          {listIconSocialLink.map(({ icon, name }, index) =>
            name === socialMediaUrls[item.socialNetwork]?.name ? (
              <p
                key={index}
                className="text-primary text-lg flex justify-center items-center"
              >
                {icon}
              </p>
            ) : undefined
          )}
        </span>
        <div className="w-full mx-4 overflow-hidden">
          <p className="text-primary_black text-[14px]">
            {socialMediaData[item.socialNetwork]?.name}
          </p>
          <p className="text-[#979797] text-[12px] w-fit line-clamp-1 overflow-hidden">
            {item.link}
          </p>
        </div>
      </a>
      <ProfileInfoEditButton
        value={item}
        roleView={roleView}
        modalName={UserSettingEnum.SocialLink}
        setModal={setModal}
      />
    </div>
  );
};

export default memo(SocialLinkComponent);
